import { dataGift } from 'dls-icons-data'
import { createIcon } from '../common'

const IconGift = /*#__PURE__*/createIcon(dataGift)
export default IconGift
